<template lang="pug">
.pre-approved-buyer(v-if="isPreApprovalBuyer")
  el-alert.warning(
    :closable="false"
    type="warning")
    .warning__layout
      i.warning__icon.bx.bxs-info-circle
      .warning__message Your account is currently under review. You will receive an email once your account is approved.
        br
        | Have questions? Email&nbsp;
        a.warning__email(
          :href="`mailto:${SALES_EMAIL}`"
          v-text="SALES_EMAIL"
          title="Contact us via email"
          v-tooltip="'Contact us via email'")
        | .
</template>

<script>
import { mapGetters } from 'vuex'
import { SALES_EMAIL } from '~/settings'

export default {
  name: 'PreApprovalBuyerWarning',

  computed: {
    ...mapGetters({
      isPreApprovalBuyer: 'authentication/isPreApprovalBuyer'
    }),

    SALES_EMAIL: () => SALES_EMAIL
  }
}
</script>

<style lang="scss" scoped>
.warning {
  &__email {
    font-weight: $--font-weight-bold;
  }
}
</style>
